/**
 * 指挥端语音未读：跨任务切换时不自动播，图标变色动画直到打开对话/播完。
 * 过期判定优先 media[].expires_at；否则按创建时间 + 默认保留天数（与后端 trackerMedia 默认 15 天对齐）。
 */

export const VOICE_MEDIA_DEFAULT_RETENTION_DAYS = 15;

export function voiceMemberKeys(payloadOrMember) {
  if (!payloadOrMember) return [];
  const keys = [];
  const id = payloadOrMember.device_unique_id != null ? String(payloadOrMember.device_unique_id).trim() : '';
  const name = payloadOrMember.name != null ? String(payloadOrMember.name).trim() : '';
  if (id) keys.push(id);
  if (name && name !== id) keys.push(name);
  return keys;
}

/** 是否仍可尝试播放（未过期） */
export function isVoicePayloadExpired(payload, nowMs = Date.now()) {
  if (!payload) return true;
  const media = Array.isArray(payload.media) ? payload.media : [];
  let sawExpires = false;
  for (let i = 0; i < media.length; i += 1) {
    const raw = media[i]?.expires_at;
    if (raw == null || raw === '') continue;
    sawExpires = true;
    const t = Date.parse(raw);
    if (Number.isFinite(t) && t > nowMs) return false;
  }
  if (sawExpires) return true;
  const created = Date.parse(payload.created_at || payload.createdAt || '');
  if (Number.isFinite(created)) {
    const ttl = VOICE_MEDIA_DEFAULT_RETENTION_DAYS * 86400 * 1000;
    return nowMs - created > ttl;
  }
  return false;
}

/**
 * 当前是否应自动播：在「任务」页且有活跃任务时，仅活跃名册内队员自动播；
 * 「全部」页仍自动播。返回 false 则只记未读。
 */
export function shouldAutoPlayVoiceForMissionContext({
  memberPanelTab,
  activeMissionId,
  missionMemberIds,
  payload,
  idMatchesMember
}) {
  const tab = String(memberPanelTab || 'all');
  if (tab !== 'mission' || !activeMissionId) return true;
  const ids = Array.isArray(missionMemberIds) ? missionMemberIds : [];
  if (!ids.length) return false;
  const keys = voiceMemberKeys(payload);
  if (!keys.length) return false;
  return ids.some((mid) => {
    const sid = String(mid || '').trim();
    if (!sid) return false;
    if (keys.includes(sid)) return true;
    if (typeof idMatchesMember === 'function') {
      try {
        return keys.some((k) => idMatchesMember(sid, { device_unique_id: k, name: k }));
      } catch (_) {
        return false;
      }
    }
    return false;
  });
}

export function summarizeUnreadForMemberIds(unreadMap, memberIds, idMatchesMember) {
  const ids = Array.isArray(memberIds) ? memberIds : [];
  const seen = new Set();
  let count = 0;
  let expiredCount = 0;
  const names = [];
  unreadMap.forEach((entry, key) => {
    if (!entry || seen.has(entry)) return;
    const hit = ids.some((mid) => {
      const sid = String(mid || '').trim();
      if (!sid) return false;
      if (sid === key) return true;
      const keys = entry.keys || voiceMemberKeys(entry);
      if (keys.includes(sid)) return true;
      if (typeof idMatchesMember === 'function') {
        try {
          return idMatchesMember(sid, { device_unique_id: entry.device_unique_id, name: entry.name });
        } catch (_) {
          return false;
        }
      }
      return false;
    });
    if (!hit) return;
    seen.add(entry);
    count += 1;
    if (isVoicePayloadExpired(entry)) expiredCount += 1;
    if (entry.name) names.push(entry.name);
  });
  return { count, expiredCount, names };
}
